export const dramas = [
  {
    id: "d1",
    title: "金瓶梅外传·清河往事",
    year: 2026,
    status: "连载",
    category: "古装 / 世情",
    director: "何砚清",
    writer: "程墨白",
    castIds: ["a1", "a2", "a3", "a6"],
    episodes: 42,
    updateTime: "2026-10-15",
    heat: 9860,
    tags: ["最新", "热播", "世情"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20elegant%20figure%20in%20flowing%20crimson%20Ming%20dynasty%20hanfu%20standing%20in%20a%20moonlit%20courtyard%20with%20plum%20blossoms%2C%20terracotta%20and%20deep%20red%20tones%2C%20muted%20ivory%20background%2C%20subtle%20gold%20leaf%20accents%2C%20soft%20candlelight%20glow%2C%20cinematic%20vertical%20composition%2C%20refined%20classical%20aesthetic%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=jpm-poster-01&orientation=portrait",
    summary: "清河县外的旧宅里，一段尘封数十年的往事因一封书信重见天日……",
    synopsis: "故事发生在清河县城外的西门旧宅。一封来自远方的陈年书信，牵出数十年前一桩被刻意掩埋的家族往事。西门家的后人陆续回到老宅，各怀心事：有人为寻真相，有人为守秘密，也有人只想在这座宅院里为自己挣得一个位置。剧集以细腻的笔触描摹市井人家的日常与人情，在柴米油盐与宴饮往来之间，铺陈出一幅生动的明代市井百态图。随着往事的层层揭开，亲情、利益与旧日恩怨交织，每个人都不得不面对自己曾经的选择。",
  },
  {
    id: "d2",
    title: "金瓶梅·风月宝鉴",
    year: 2026,
    status: "连载",
    category: "古装 / 悬疑",
    director: "何砚清",
    writer: "程墨白",
    castIds: ["a1", "a2", "a4", "a8"],
    episodes: 38,
    updateTime: "2026-10-13",
    heat: 9420,
    tags: ["最新", "悬疑", "热播"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20lone%20figure%20holding%20a%20bronze%20mirror%20in%20a%20dim%20study%20lit%20by%20oil%20lamp%2C%20deep%20crimson%20and%20warm%20amber%20tones%2C%20muted%20ivory%20background%2C%20gold%20frame%20details%2C%20mysterious%20moody%20atmosphere%2C%20cinematic%20vertical%20composition%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=jpm-poster-02&orientation=portrait",
    summary: "一面古镜、一桩旧案，真相在人心明暗之间层层反转。",
    synopsis: "一面相传能「照见人心」的古镜流入清河县，随之而来的是一连串蹊跷事件。年轻的捕快受命查案，却发现线索都指向城中几户显赫人家。随着调查深入，镜子的传说逐渐褪去神秘色彩，真正被照见的，是每个人藏在体面之下的贪念与恐惧。剧集以悬疑为骨、世情为肉，在环环相扣的案件推进中，勾勒出复杂的人性光谱。",
  },
  {
    id: "d3",
    title: "金瓶梅全传·市井风云",
    year: 2025,
    status: "完结",
    category: "古装 / 世情",
    director: "吴承澜",
    writer: "苏子衿",
    castIds: ["a1", "a3", "a4", "a9"],
    episodes: 50,
    updateTime: "2025-12-28",
    heat: 8210,
    tags: ["完结", "经典"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20bustling%20Ming%20dynasty%20market%20street%20with%20lanterns%20and%20merchants%2C%20deep%20terracotta%20red%20and%20warm%20beige%20tones%2C%20layered%20townspeople%20silhouettes%2C%20muted%20ivory%20light%2C%20cinematic%20vertical%20composition%2C%20rich%20narrative%20detail%2C%20no%20text&width=600&height=900&seq=jpm-poster-03&orientation=portrait",
    summary: "一座县城，几户人家，半部明代市井众生相。",
    synopsis: "全剧以清河县为舞台，通过几户人家数十年间的兴衰起落，描摹出明代中后期市井社会的鲜活图景。商贸、婚嫁、节庆、讼事，日常的涓涓细流汇成时代的洪流，剧中人物在人情世故的经纬里挣扎、妥协与成长。剧集力求还原一个有烟火气、有温度的古代市井世界。",
  },
  {
    id: "d4",
    title: "金瓶梅·西门风云录",
    year: 2025,
    status: "完结",
    category: "古装 / 家族",
    director: "吴承澜",
    writer: "苏子衿",
    castIds: ["a1", "a5", "a9"],
    episodes: 46,
    updateTime: "2025-11-09",
    heat: 7680,
    tags: ["完结", "家族"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20grand%20Ming%20dynasty%20mansion%20gate%20with%20stone%20lions%20and%20hanging%20red%20lanterns%2C%20deep%20crimson%20and%20charcoal%20grey%20tones%2C%20muted%20ivory%20sky%2C%20gold%20roof%20accents%2C%20cinematic%20vertical%20composition%2C%20dignified%20mood%2C%20no%20text&width=600&height=900&seq=jpm-poster-04&orientation=portrait",
    summary: "深宅大院之内，人情冷暖写尽一个家族的荣枯。",
    synopsis: "西门家的深宅大院是整部剧的核心舞台。宅门之内，是主仆尊卑、妯娌明争与账房暗斗；宅门之外，是行商坐贾、官场往来与市井流言。剧集以家族视角切入，写尽一个大家族由盛转衰的漫长过程，其中既有利益的算计，也有血缘与情义的羁绊。",
  },
  {
    id: "d5",
    title: "金瓶梅·兰陵旧梦",
    year: 2024,
    status: "完结",
    category: "古装 / 情感",
    director: "沈知远",
    writer: "柳含烟",
    castIds: ["a2", "a6"],
    episodes: 36,
    updateTime: "2024-09-20",
    heat: 6540,
    tags: ["完结", "情感"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20woman%20in%20pale%20ivory%20robe%20gazing%20at%20distant%20mountains%20from%20a%20wooden%20pavilion%2C%20soft%20muted%20red%20and%20sage%20tones%2C%20ivory%20mist%20background%2C%20delicate%20gold%20linework%2C%20melancholic%20serene%20mood%2C%20cinematic%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=jpm-poster-05&orientation=portrait",
    summary: "旧梦如烟，一段被时光掩埋的情与义。",
    synopsis: "故事围绕一段跨越十余年的旧日情缘展开。当年离散的两人在命运的捉弄下再度相逢，却发现彼此早已走上截然不同的人生道路。剧集以舒缓细腻的节奏，讲述人在时代与礼法之间的身不由己，以及在遗憾中学会释怀的过程。",
  },
  {
    id: "d6",
    title: "金瓶梅·紫石街传奇",
    year: 2024,
    status: "完结",
    category: "古装 / 传奇",
    director: "沈知远",
    writer: "柳含烟",
    castIds: ["a2", "a7"],
    episodes: 40,
    updateTime: "2024-07-15",
    heat: 5980,
    tags: ["完结", "传奇"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20narrow%20stone%20paved%20street%20lined%20with%20wooden%20shopfronts%20and%20red%20lanterns%20at%20dusk%2C%20warm%20terracotta%20and%20amber%20tones%2C%20muted%20ivory%20sky%2C%20gold%20lantern%20glow%2C%20cinematic%20vertical%20composition%2C%20lively%20nostalgic%20mood%2C%20no%20text&width=600&height=900&seq=jpm-poster-06&orientation=portrait",
    summary: "一条老街，几代人的悲欢与传奇。",
    synopsis: "紫石街是清河县最热闹也最复杂的地方，三教九流、行商坐贾在此交汇。剧集以这条老街为中心，串联起几个普通人家在数十年间的悲欢离合。他们有各自的算计与善意，在时代的浪头里或沉或浮，共同写就一段属于市井民间的传奇。",
  },
  {
    id: "d7",
    title: "金瓶梅·金莲记",
    year: 2023,
    status: "完结",
    category: "古装 / 人物",
    director: "岳清川",
    writer: "顾之遥",
    castIds: ["a3", "a5"],
    episodes: 34,
    updateTime: "2023-11-30",
    heat: 7120,
    tags: ["完结", "人物"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20young%20woman%20in%20deep%20crimson%20embroidered%20robe%20seated%20by%20a%20lattice%20window%20with%20plum%20branch%2C%20rich%20red%20and%20gold%20tones%2C%20muted%20ivory%20interior%2C%20expressive%20thoughtful%20expression%2C%20cinematic%20vertical%20composition%2C%20elegant%20classical%20aesthetic%2C%20no%20text&width=600&height=900&seq=jpm-poster-07&orientation=portrait",
    summary: "以人物刻画为核心，重述一个家喻户晓的古典形象。",
    synopsis: "本剧尝试从人物本身出发，重新审视一位被反复书写的古典女性形象。剧集不着眼于评判，而是耐心铺陈她所处的环境、遭遇与人际关系，还原一个在特定时代语境内真实可感的普通人。通过对日常细节的细腻刻画，让观众在熟悉的故事里看到新的理解角度。",
  },
  {
    id: "d8",
    title: "金瓶梅·瓶儿传",
    year: 2023,
    status: "完结",
    category: "古装 / 人物",
    director: "岳清川",
    writer: "顾之遥",
    castIds: ["a3", "a8"],
    episodes: 32,
    updateTime: "2023-08-18",
    heat: 6320,
    tags: ["完结", "人物"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20gentle%20woman%20in%20pale%20rose%20silk%20robe%20arranging%20flowers%20in%20an%20ivory%20vase%20by%20soft%20window%20light%2C%20muted%20rose%20and%20cream%20tones%2C%20delicate%20gold%20accents%2C%20quiet%20tender%20mood%2C%20cinematic%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=jpm-poster-08&orientation=portrait",
    summary: "温柔与坚韧并存，一个女子的半生沉浮。",
    synopsis: "剧集聚焦一位性情温婉却命运多舛的女子，讲述她从寻常人家走进深宅后的半生经历。面对复杂的人际与接踵而至的变故，她始终保有一份难得的善意与韧性。剧集以克制的笔法描摹她的选择与坚持，呈现出一个在时代夹缝中努力活出自我的人物。",
  },
  {
    id: "d9",
    title: "金瓶梅·春梅外传",
    year: 2022,
    status: "完结",
    category: "古装 / 世情",
    director: "岳清川",
    writer: "陶见微",
    castIds: ["a4", "a7"],
    episodes: 30,
    updateTime: "2022-12-10",
    heat: 5240,
    tags: ["完结", "世情"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20spirited%20young%20maidservant%20in%20pale%20gold%20robe%20carrying%20a%20tray%20through%20a%20courtyard%20corridor%2C%20warm%20amber%20and%20cream%20tones%2C%20muted%20ivory%20background%2C%20gold%20accent%20linework%2C%20lively%20graceful%20mood%2C%20cinematic%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=jpm-poster-09&orientation=portrait",
    summary: "从小院到深宅，一个伶俐女子的成长之路。",
    synopsis: "这是一部以「成长」为主线的世情剧。出身寻常的女主角凭着一股机灵劲儿和不服输的韧劲，在深宅大院里一步步为自己挣得一席之地。剧集既写她的聪慧与谋略，也写她的迷茫与代价，展现一个小人物在复杂环境中保全本心、寻找出路的过程。",
  },
  {
    id: "d10",
    title: "金瓶梅·月娘当家",
    year: 2022,
    status: "完结",
    category: "古装 / 家族",
    director: "程守拙",
    writer: "陶见微",
    castIds: ["a5", "a8"],
    episodes: 28,
    updateTime: "2022-06-25",
    heat: 4880,
    tags: ["完结", "家族"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20composed%20woman%20in%20dark%20crimson%20robe%20holding%20an%20account%20ledger%20in%20a%20dim%20ancestral%20hall%2C%20deep%20red%20and%20charcoal%20tones%2C%20muted%20ivory%20light%2C%20gold%20candle%20accents%2C%20steady%20dignified%20mood%2C%20cinematic%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=jpm-poster-10&orientation=portrait",
    summary: "当家主母如何在内忧外患中撑起一个家。",
    synopsis: "丈夫骤然离世，偌大的家业一下子压在了当家主母肩上。她要安抚人心、打理生计、周旋于各方势力之间，还要守住孩子们的前程。剧集以家族经营为线索，刻画一位女性在困境中的担当与智慧，也展现了传统家族制度下女性的处境与韧性。",
  },
  {
    id: "d11",
    title: "金瓶梅·狮子楼迷案",
    year: 2021,
    status: "完结",
    category: "古装 / 悬疑",
    director: "程守拙",
    writer: "陶见微",
    castIds: ["a6", "a9"],
    episodes: 26,
    updateTime: "2021-10-08",
    heat: 4360,
    tags: ["完结", "悬疑"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20atmospheric%20night%20scene%20of%20a%20two%20story%20wooden%20tavern%20with%20lanterns%20and%20rain%2C%20deep%20crimson%20and%20ink%20grey%20tones%2C%20muted%20ivory%20mist%2C%20gold%20lantern%20glow%2C%20tense%20mysterious%20mood%2C%20cinematic%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=jpm-poster-11&orientation=portrait",
    summary: "一处酒楼，一桩迷案，真相藏在流言之下。",
    synopsis: "狮子楼本是城中颇有名的酒楼，一桩发生在楼中的意外却让这里蒙上阴霾。众人各执一词，流言越传越玄。一位经验老到的官吏接手查办，在抽丝剥茧中还原出事情的原委。剧集以案件为引子，写人情、写世相，也写在小城里流传的偏见的杀伤力。",
  },
  {
    id: "d12",
    title: "金瓶梅·清河烟云",
    year: 2021,
    status: "完结",
    category: "古装 / 世情",
    director: "程守拙",
    writer: "陶见微",
    castIds: ["a7", "a8", "a9"],
    episodes: 24,
    updateTime: "2021-05-16",
    heat: 3980,
    tags: ["完结", "世情"],
    cover: "https://readdy.ai/api/search-image?query=traditional%20Chinese%20gongbi%20painting%20style%20drama%20poster%2C%20panoramic%20view%20of%20a%20misty%20riverside%20town%20with%20tiled%20roofs%20and%20distant%20mountains%20at%20dawn%2C%20soft%20crimson%20and%20warm%20grey%20tones%2C%20ivory%20fog%20layers%2C%20delicate%20gold%20light%20accents%2C%20serene%20reflective%20mood%2C%20cinematic%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=jpm-poster-12&orientation=portrait",
    summary: "烟云散尽，一座小城的众生与日常。",
    synopsis: "以清河县的一年间为时间线，剧集用近乎白描的方式记录城中普通人家的一年四季。春耕、夏宴、秋收、冬祭，生活的节拍缓慢而真实。在看似平淡的日常里，藏着普通人的坚守、期盼与小小的欢喜，是一曲写给市井生活的温柔小调。",
  },
];